import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { marked } from 'marked';
import { usePreserveSearch } from '../../Hooks/usePreserveSearch';

const MARKDOWN_URL = `${process.env.PUBLIC_URL ?? ''}/privacy-policy.md`;

export function PrivacyPolicyPage() {
   const { chatPath } = usePreserveSearch();
   const [html, setHtml] = useState<string>('');
   const [error, setError] = useState<string | null>(null);
   const [loading, setLoading] = useState(true);

   useEffect(() => {
      let cancelled = false;

      (async () => {
         try {
            const res = await fetch(MARKDOWN_URL);
            if (!res.ok) {
               throw new Error(`Failed to load privacy policy (${res.status})`);
            }
            const md = await res.text();
            if (cancelled) return;
            const parsed = marked.parse(md, { async: false }) as string;
            setHtml(parsed);
            setError(null);
         } catch (e) {
            if (!cancelled) {
               setError(e instanceof Error ? e.message : 'Could not load privacy policy.');
            }
         } finally {
            if (!cancelled) setLoading(false);
         }
      })();

      return () => {
         cancelled = true;
      };
   }, []);

   return (
      <div className="flex flex-col w-full min-w-0 flex-1 min-h-0 h-full bg-slate-50">
         <header className="flex-shrink-0 flex items-center gap-4 px-4 sm:px-6 py-3 bg-white/90 border-b border-gray-100 shadow-sm w-full">
            <Link
               to={chatPath}
               className="text-sm font-medium text-blue-600 hover:text-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded"
            >
               ← Back to chat
            </Link>
            <span className="text-sm text-gray-500">Privacy Policy</span>
         </header>

         <div className="flex-1 min-h-0 w-full overflow-y-auto overflow-x-hidden">
            <div className="w-full max-w-full box-border px-4 sm:px-6 lg:px-10 py-6 sm:py-8 pb-16">
               {loading && <p className="text-gray-600">Loading…</p>}
               {error && (
                  <div className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-red-800 text-sm max-w-full">
                     {error}
                  </div>
               )}
               {!loading && !error && (
                  <article
                     className="privacy-policy-md privacy-policy-md--full w-full max-w-full bg-white rounded-xl shadow-sm border border-gray-100 px-4 py-6 sm:px-8 sm:py-8 box-border"
                     dangerouslySetInnerHTML={{ __html: html }}
                  />
               )}
            </div>
         </div>
      </div>
   );
}
